import { enderecoEncontradoSchema, type EnderecoEncontrado } from '@plane/shared';

import { apiRequest } from '@/services/http-client';

/** Procura as coordenadas de um endereço escrito. */
export function buscarEndereco(consulta: string): Promise<EnderecoEncontrado> {
  const busca = new URLSearchParams({ q: consulta });

  return apiRequest(`/api/v1/geocode?${busca.toString()}`, enderecoEncontradoSchema);
}
